import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgEMail = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#E-Mail_svg__a)">
      <mask
        id="E-Mail_svg__b"
        width={32}
        height={13}
        x={4}
        y={10}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M36 10H4v13h32z"
        />
      </mask>
      <g
        fill="#FED27A"
        mask="url(#E-Mail_svg__b)"
      >
        <path d="m45.18 40.09-12.25-7.07L40 20.77zM40 20.77l-7.07 12.25-12.25-7.07zM-3.81 11.81 3.26-.44l12.25 7.07z" />
        <path d="m15.51 6.63 12.24 7.07-7.07 12.25zM40 20.77 27.75 13.7l7.07-12.25z" />
        <path d="M34.82 1.45 27.75 13.7 15.51 6.63zM20.68 25.95l7.07-12.25L40 20.77zM-3.81 11.81l12.24 7.07-7.07 12.25z" />
        <path d="M20.68 25.95 8.43 18.88l7.08-12.25z" />
        <path d="M15.51 6.63 8.43 18.88l-12.24-7.07zM1.36 31.13l7.07-12.25 12.25 7.07zM34.82 1.45l12.25 7.08L40 20.77z" />
      </g>
      <mask
        id="E-Mail_svg__c"
        width={32}
        height={20}
        x={4}
        y={10}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="m4 10 16 10 16-10v20H4z"
        />
      </mask>
      <g mask="url(#E-Mail_svg__c)">
        <path
          fill="#F7A941"
          d="m6.43 17.73-12.24-7.08L1.26-1.59z"
        />
        <path
          fill="#F7A941"
          d="m-12.88 22.9 7.07-12.25 12.24 7.08zM25.75 12.55 13.51 5.48l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m1.26-1.59 12.25 7.07-7.08 12.25z"
        />
        <path
          fill="#F18700"
          d="m6.43 17.73 7.08-12.25 12.24 7.07z"
        />
        <path
          fill="#F7A941"
          d="m6.43 17.73 12.25 7.07-7.07 12.24z"
        />
        <path
          fill="#F18700"
          d="M30.93 31.87 18.68 24.8l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="M25.75 12.55 18.68 24.8 6.43 17.73z"
        />
        <path
          fill="#F7A941"
          d="m11.61 37.04 7.07-12.24 12.25 7.07zM11.61 37.04-.64 29.97l7.07-12.24z"
        />
        <path
          fill="#F7A941"
          d="M6.43 17.73-.64 29.97l-12.24-7.07z"
        />
        <path
          fill="#F18700"
          d="m-7.71 42.22 7.07-12.25 12.25 7.07zM50.25 26.69l-7.07 12.25-12.25-7.07zM20.58-6.77 32.82.3l-7.07 12.25z"
        />
        <path
          fill="#F7A941"
          d="M25.75 12.55 32.82.3l12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="M25.75 12.55 38 19.62l-7.07 12.25z"
        />
        <path
          fill="#F18700"
          d="M45.07 7.37 38 19.62l-12.25-7.07zM30.93 31.87 38 19.62l12.25 7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="E-Mail_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgEMail);

export default ForwardRef;
